import {Component, OnInit} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {MatDialog} from "@angular/material/dialog";
import {IUser} from "../../../interfaces";
import {AppService, StoreSelectorsService} from "../../../services";
import {Router} from "@angular/router";
import {formatBytes, LIMIT_FREE_STORAGE, LIMIT_SUBSCRIBE_STORAGE, SUPPORTED_FILE_TYPES} from '../../../common';
import {Color, ScaleType} from '@swimlane/ngx-charts';
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: 'app-resource-dashboard',
    templateUrl: './resource-dashboard.component.html',
    styleUrls: ['./resource-dashboard.component.scss']
})
export class ResourceDashboardComponent extends Compbaser implements OnInit {
    /** resource mini dashboard variables */
    user: IUser;
    showDash = false;
    requireAccountUpgrade = false;
    resourceStatistics = [];
    resourceTypes: Array<string>;
    totalStorageLabel: string;
    view1: [number, number] = [500, 300];
    view2: [number, number] = [450, 270];

    colorScheme: Color = {
        name: 'Customer Usage',
        selectable: true,
        group: ScaleType.Ordinal,
        domain: ['#5AA454', '#E44D25', '#aae3f5', '#CFC0BB', '#7aa3e5', '#a8385d', '#5AA454', '#E44D25', '#aae3f5', '#CFC0BB', '#7aa3e5', '#a8385d']
    };

    dataStoragePercent = [
        {
            name: "cloud storage",
            value: 0
        },
        {
            name: "used storage",
            value: 0
        }
    ];

    constructor(
        public storeSelector: StoreSelectorsService,
        public router: Router,
        private appService: AppService,
        protected override dialog: MatDialog,
        private translocoService: TranslocoService
    ) {
        super();
        this.setMe('resource-dashboard.component.ts');
        this.totalStorageLabel = this.translocoService.translate('ai.totalStorage', {}, this.translocoService.getActiveLang());
        this.resourceTypes = SUPPORTED_FILE_TYPES.filter(e => e !== 'jpeg');
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                })
        );
        this.cod(
            this.storeSelector.getResources()
                .subscribe((i_resource) => {
                    const resourcesByType = {};
                    this.resourceTypes.forEach((type) => {
                        resourcesByType[type] = 0;
                    });
                    let totalSize = 0;

                    i_resource.forEach((s, idx) => {
                        totalSize += parseInt(s.resource_bytes_total);

                        const res_type = s.resource_type.toLowerCase();
                        if (!SUPPORTED_FILE_TYPES.includes(res_type)) return;

                        switch (res_type) {
                            case "flv": {
                                resourcesByType['flv']++;
                                break;
                            }
                            case "m4v": {
                                resourcesByType['m4v']++;
                                break;
                            }
                            case "mp4": {
                                resourcesByType['mp4']++;
                                break;
                            }
                            case "jpeg":
                            case "jpg": {
                                resourcesByType['jpg']++;
                                break;
                            }
                            case "png": {
                                resourcesByType['png']++;
                                break;
                            }
                            case "gif": {
                                resourcesByType['gif']++;
                                break;
                            }
                            case "svg": {
                                resourcesByType['svg']++;
                                break;
                            }
                            case "swf": {
                                resourcesByType['swf']++;
                                break;
                            }
                            default: {
                                resourcesByType['other']++;
                                break;
                            }
                        }
                    });

                    this.resourceStatistics = Array.from(this.resourceTypes, key => ({
                        name: key,
                        value: resourcesByType[key]
                    })).sort((a, b) => b.value - a.value);

                    const cloudMaxStorage = this.user.enterprise ? LIMIT_SUBSCRIBE_STORAGE : LIMIT_FREE_STORAGE;
                    totalSize = Math.min(totalSize, cloudMaxStorage);
                    const freeStorage = cloudMaxStorage - totalSize;
                    if (freeStorage === 0) {
                        this.requireAccountUpgrade = true;
                    }

                    this.dataStoragePercent = [
                        // {
                        //     name: "cloud storage (MB)",
                        //     value: cloudMaxStorage
                        //     // value: (cloudMaxStorage / 1024) - Math.round(totalSize / 1024)
                        // },
                        {
                            name: "used storage",
                            value: totalSize
                        },
                        {
                            name: "free storage",
                            value: freeStorage
                        }
                    ];
                })
        );
    }

    formatPercentStorageValue = (val) => {
        return parseFloat(val).toFixed(2);
    };

    formatStorageValue = (val) => {
        return formatBytes(val, 2);
    };

    upgrade() {
        this.dialog.closeAll();
        this.appService.openWizardUpgradeDialog();
        this.router.navigateByUrl('/home');
    }
}
